import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-thumbnail-loader-skeleton',
  templateUrl: './file-thumbnail-loader-skeleton.component.html'
})
export class FileThumbnailLoaderSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
